export const cardLayout =(color)=>{
    return `<svg width="438" height="614" viewBox="0 0 438 614" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g filter="url(#filter0_b_0_150)">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M0 29C0 12.9837 12.9837 0 29 0H409C425.016 0 438 12.9837 438 29V106C432.477 106 428 110.477 428 116C428 121.523 432.477 126 438 126V585C438 601.016 425.016 614 409 614H29C12.9837 614 0 601.016 0 585V126C5.52285 126 10 121.523 10 116C10 110.477 5.52285 106 0 106V29Z" fill="${color}"/>
    </g>
    <defs>
    <filter id="filter0_b_0_150" x="-30" y="-30" width="498" height="674" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
    <feFlood flood-opacity="0" result="BackgroundImageFix"/>
    <feGaussianBlur in="BackgroundImageFix" stdDeviation="15"/>
    <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_0_150"/>
    <feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_0_150" result="shape"/>
    </filter>
    </defs>
    </svg>`
} 



